"use client";

import React from "react";
import { ArrowRight } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function TheCreativeSpark() {
  const {
    ref: textRef,
    isVisible: textVisible
  } = useRevealOnScroll();
  const {
    ref: visualRef,
    isVisible: visualVisible
  } = useRevealOnScroll();
  return <section data-section-id="37232" id="premium-roofing-excellence" className="bg-background text-foreground relative min-h-[90vh] flex items-center overflow-hidden py-20 px-6 md:px-12 lg:px-24 dark">
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden pointer-events-none z-0">
        <div className="absolute top-[-20%] left-[-10%] w-[50vw] h-[50vw] bg-primary/10 rounded-lg blur-[150px]" />
        <div className="absolute bottom-[-20%] right-[-10%] w-[60vw] h-[60vw] bg-primary/5 rounded-lg blur-[150px]" />
      </div>

      <div className="container mx-auto grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-20 xl:gap-32 items-center relative z-10">
        <div ref={textRef} className={`flex flex-col gap-8 max-w-2xl lg:max-w-none transition-all duration-1000 ease-out ${textVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10"}`}>
          <span className="text-sm md:text-base font-bold uppercase tracking-[0.3em] text-primary/80">
            OFFICIAL SITE
          </span>
          <h1 className="font-serif font-bold text-6xl md:text-8xl lg:text-9xl tracking-tighter text-primary leading-[0.9] drop-shadow-2xl">
            FIVE STAR
ROOFLINE
          </h1>
          <p className="font-sans font-bold uppercase tracking-[0.3em] text-primary/60 -mt-6 !text-2xl">
            FSR | Roofing & Roofline Specialists
          </p>

          <p className="font-sans font-medium text-xl md:text-2xl leading-relaxed text-transparent bg-clip-text bg-gradient-to-r from-primary via-foreground to-muted-foreground max-w-xl backdrop-blur-sm">
            Five Star Roofline North East has been serving customers across Tyneside and the wider North East since 2019. As our business has grown, we've introduced FSR as a shorter, cleaner way to recognise the same trusted name. We specialise in uPVC roofline replacements, dry verge systems, dry ridge systems, EPDM rubber roofing and roof repairs, delivering reliable, high-quality workmanship built to last.
          </p>

          <div className="pt-4 flex flex-wrap gap-4">
            <Button asChild variant="outline" className="h-16 px-10 text-lg md:text-xl border-2 border-primary bg-primary text-primary-foreground hover:bg-primary/90 hover:text-primary-foreground hover:border-primary transition-all duration-300 rounded-lg hover:shadow-[0_0_40px_rgba(234,179,8,0.5)] group relative overflow-hidden">
              <Link to="#get-quote-form" onClick={e => {
              e.preventDefault();
              document.getElementById("get-quote-form")?.scrollIntoView({
                behavior: "smooth"
              });
            }}>
                <span className="relative z-10 flex items-center gap-3 font-bold uppercase tracking-wider">
                  Get Your Free Quote
                  <ArrowRight className="w-6 h-6 transition-transform duration-300 group-hover:translate-x-1" />
                </span>
                <span className="absolute inset-0 bg-white/20 animate-pulse z-0" />
              </Link>
            </Button>
          </div>

          <div className="flex flex-col md:flex-row gap-4 justify-start lg:justify-start mt-8">
            <Button asChild className="h-12 md:h-14 px-6 md:px-8 text-sm md:text-base font-bold uppercase tracking-widest bg-gradient-to-r from-primary to-primary/70 text-primary-foreground border-none hover:shadow-[0_0_20px_rgba(234,179,8,0.4)] transition-all duration-300 rounded-lg">
              <Link to="https://fivestarsroofline.com/services/">Our Services</Link>
            </Button>
            <Button asChild variant="outline" className="h-12 md:h-14 px-6 md:px-8 text-sm md:text-base font-bold uppercase tracking-widest border-primary/50 text-primary hover:bg-primary/10 hover:border-primary transition-all duration-300 rounded-lg">
              <Link to="https://fivestarsroofline.com/areas-we-cover/">Areas We Cover</Link>
            </Button>
          </div>
        </div>

        <div ref={visualRef} className={`relative flex justify-center lg:justify-end items-center transition-all duration-1000 delay-300 ease-out ${visualVisible ? "opacity-100 translate-x-0" : "opacity-0 translate-x-10"}`}>
          <div className="relative w-full max-w-md md:max-w-lg lg:max-w-full aspect-square">
            <div className="absolute inset-0">
              <img src="https://fivestarsroofline.com/wp-content/uploads/2026/03/639450685_1508805101245920_194738150268176335_n.jpg" alt="Premium Roofing Architecture" className="w-full h-full object-contain lg:object-right opacity-90 brightness-110 drop-shadow-[0_0_50px_rgba(234,179,8,0.4)]" />
            </div>

            <div className="absolute inset-0 flex items-center justify-center pointer-events-none">
              <div className="w-1/2 h-1/2 bg-primary/20 rounded-lg blur-[80px] animate-pulse" />
            </div>
          </div>
        </div>
      </div>
    </section>;
}